<template>
    <div class="modal fade" id="contractReport" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mb-2">
                    <h1 class="modal-title mt-0 heading-large">
                        <span>{{selectedContract.reference}}</span>
                    </h1>
                    <button type="button" class="modal-close" @click="closeModal()" aria-label="Close">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div class="modal-body mb-2">
                    <div class="table-container px-0">
                        <table class="table responsive-table">
                            <thead class="thead-light">
                                <tr class="d-none d-lg-table-row">
                                    <th>Seller</th>
                                    <th> Terminal/Network </th>
                                    <th> Measurement </th>
                                    <th> Lifting Period </th>
                                    <th> Total Vol/L </th>
                                    <th> Duration </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="w-100">
                                    <td label="Seller"> <span>{{selectedContract.seller}}</span> </td>
                                    <td label="Terminal/Network"> <span>{{selectedContract.location}}</span> </td>
                                    <td label="Measurement"> <span>{{selectedContract.measurement | fuelmeasurementtype}}</span> </td>
                                    <td label="Lifting Period"> <span>{{selectedContract.collectionDays | collectiondaysformat}}</span> </td>
                                    <td label="Total Vol/L"> <span>{{selectedContract.totalVol | volumeformat}}</span> </td>
                                    <td label="Duration"> <span>{{getDuration(selectedContract)}} Months</span> </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-md-12">
                            <h2 class="heading-small">Contract Breakdown</h2>
                            <div class="table-container px-0">
                                <table class="table responsive-table">
                                    <thead style="text-align:center">
                                        <tr>
                                          <th>  Month</th>
                                          <th>  Expiry Date </th>
                                          <th>  Volume Triggered/L </th>
                                          <th>  Volume Remaining/L </th>
                                          <th>  Monthly Volume/L </th>
                                      </tr>
                                  </thead>
                              
                                  <tbody v-if="selectedContract.frequencyQty" >
                                      <tr style="text-align:center" v-for="(month, key) in selectedContract.frequencyQty" :key="key">
                                          <td label="Month">  <span>{{key + 1}} </span></td>
                                          <td label="Expiry Date"> <span> {{formatUntilDate(month) | dateformat}} </span> </td>
                                          <td label="Triggered Volume"> <span> {{(month.quantity - month.maximumAvailable) | volumeformat}} </span> </td>
                                          <td label="Remaining Volume"> <span> {{month.maximumAvailable | volumeformat}} </span> </td>
                                          <td label="Volume/L"> <span> {{month.quantity | volumeformat}} </span> </td>
                                        </tr>
                                    </tbody> 
                                        
                                  <tbody v-else >
                                    <tr v-for="(month, key) in getEndOfEachMonth(selectedContract)" :key="key">
                                      <td label="Month"> <span> {{key +1}} </span> </td>
                                      <td label="Expiry Date">  <span>{{month.endDate | dateformat}}</span></td>
                                      <td label="Volume/L" class="text-right"><span>  {{month.volume | volumeformat}} </span> </td>
                                    </tr>
                                  </tbody> 
                                </table>
                            </div> 
                        </div>
                        <div class="col-lg-7 col-md-12">
                            <h2 class="heading-small">Trigger Contract Utilisation Report</h2>
                            <div class="card px-3 pt-1 pb-3">
                                <div>
                                    <div class="d-flex justify-content-between">
                                        <h3 class="heading-xsmall"> Current Month: {{getCurrentMonth()}} </h3>
                                        <h3 class="heading-xsmall"> 
                                            <i 
                                                class="fas fa-lg fa-info-circle text-secondary mb-2"
                                                data-toggle="tooltip" data-placement="bottom" 
                                                title="Please note volume must be triggered by the last working day of this month."
                                            ></i>
                                            Current Month Expiry: {{getEndOfCurrentMonth() | dateformat}} 
                                        </h3>
                                    </div>
                                    <div>
                                        <apexchart type="donut" :options="options" :series="getSeriesData(selectedContract)"></apexchart>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>       
            </div>
        </div>   
    </div>      
</template>

<script>
import moment from 'moment'

export default {
    data(){
        return {
            options: {
                chart: {
                    width: 200,
                },
                legend: {
                    position: 'right',
                    showForNullSeries: true,
                    showForZeroSeries: true,
                    horizontalAlign: 'bottom', 
                },
                colors: ['#41B749','#C6F6D5'],
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            if (val !== undefined) {
                                val = val.toLocaleString();
                            }
                            return val
                        },
                    },
                },  
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                        return val.toFixed(2) + '%'
                    },
                },          
                labels: ["Triggered Volume", "Remaining Volume"],
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    show: true,
                                    formatter: function (val) {
                                        return Number(val).toLocaleString();
                                    },
                                }
                            },
                            
                        }
                    }
                }
            }
        }
    },
    props:['selectedContract'],
    component:{
        VueApexCharts: 'apexchart'
    },
    mounted() {
        $('#contractReport').modal('show')
        $('[data-toggle="tooltip"]').tooltip()

        const that = this

        $('#contractReport').on('hidden.bs.modal', function () {
            that.$emit('hideContractReport')
        })
    },
    methods: {
        getSeriesData(selectedContract){
            let triggered;
            let remaining;

            if(selectedContract.frequencyQty && selectedContract.frequencyQty.length > 0){
                let month = this.getCurrentMonthData(selectedContract);
                triggered = month.quantity - month.maximumAvailable;
                remaining = month.maximumAvailable;
            } else{
                triggered = selectedContract.totalVol - selectedContract.maximumAvailable;
                remaining = selectedContract.maximumAvailable;
            }

            return [triggered, remaining ]
        },
        getDuration(selectedContract){
            const monthDifference =  moment(selectedContract.end).diff(new Date(selectedContract.start), 'months', true);
            selectedContract.duration = monthDifference.toFixed(0);
            return selectedContract.duration;
        },
        formatUntilDate(month){
            return moment(month.until_date);
        },
        getEndOfEachMonth(selectedContract){

            const duration = this.getDuration(selectedContract);
            const start = new Date(selectedContract.start);
            let endDate;
            let months = [];
        
            for(let i =0; i< duration; i++){
                endDate = new Date(start.getFullYear(), start.getMonth() + (1 + i), 0);
                months.push({"endDate":moment(endDate), "volume":selectedContract.totalVol});
            }
            return selectedContract.months = months;
        },
        getEndOfCurrentMonth(){
            return moment().endOf('month');
        },
        getCurrentMonth() {
            return moment().format('MMMM YYYY');
        },
        getCurrentMonthData(selectedContract){
            const now = new Date();
            
            for(let i = 0; i < selectedContract.frequencyQty.length; i++){
                let until = new Date(selectedContract.frequencyQty[i].until_date);
                if(now.getMonth() === until.getMonth() && now.getFullYear() === until.getFullYear()){
                    return  selectedContract.frequencyQty[i];
                } 
            }
        },
        closeModal(){
            $('#contractReport').modal('hide')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>

